<template>
  <div style="display: flex;">
    <ImgView :src="carForm.img" />
    <div>
      <div>
        <el-form ref="form" :model="carForm" label-width="120px">
          <el-form-item label="实名：" style="margin-bottom: 8px;">
<!--            <span>{{carForm.identityAuth.overallAuthState==2?carForm.identityAuth.identityName:''}}</span>-->
            {{ carForm.identityAuth.identityState == 2?carForm.identityAuth.identityName:carForm.identityAuth.zhimaState == 1?carForm.identityAuth.zhimaCertName + ' (芝麻)':carForm.identityAuth.baiduState == 1?carForm.identityAuth.baiduCertName + ' (百度)':'' }}
          </el-form-item>
          <el-form-item label="车辆品牌：">
            <el-input type="text" v-model="carForm.carName" placeholder="请输入车品牌"  style="width:28em;"></el-input>
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-radio-group v-model="state">
              <el-radio-button :label="2">通过 <i class="el-icon-check" v-show="state==2"></i></el-radio-button>
              <el-radio-button :label="3">不通过 <i class="el-icon-check" v-show="state==3"></i></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="不通过原因：" v-show="state==3">
            <el-input type="textarea" v-model="carForm.remark" placeholder="不通过原因仅用户可见" style="width:28em;margin-bottom: 8px;"></el-input>
            <el-radio-group v-model="msg" @change="msgChange">
              <el-radio :label="'请上传行驶证或购车证明等真实有效的材料。'">请上传行驶证或购车证明等真实有效的材料</el-radio>
              <el-radio :label="'身份证未认证成功。请先完善身份证资料，再上传认证材料。'">身份证未认证成功。请先完善身份证资料，再上传认证材料</el-radio>
              <el-radio :label="'该材料显示的车辆所有人名字，与用户实名不一致，请重新上传材料。'" style="margin-top: 8px;margin-bottom: 8px;">
                <p style="white-space: normal;line-height: 20px;">该材料显示的车辆所有人名字，与用户实名不一致，请重新上传材料</p>
              </el-radio>
              <el-radio :label="'材料过于模糊，无法审核。请重新上传清晰材料。'">材料过于模糊，无法审核。请重新上传清晰材料</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="材料类型：">
            <el-radio-group v-model="authType" style="line-height:18px;padding-top:3px;">
              <el-radio :label="0">其他材料</el-radio>
              <el-radio :label="1">行驶证</el-radio>
              <el-radio :label="2">购车证明</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" style="text-align: center">
        <el-button size="medium" @click="cancel">返 回</el-button>
        <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateAuthCar } from '@/api/url'
import { postFormData } from '@/api/api'
import ImgView from "@/views/auth/components/ImgView";

export default {
  name: "JobDialog",
  components: { ImgView },
  props: {
    value: Object
  },
  data() {
    return {
      carForm: this.value.carForm,
      authType: this.value.carForm.authType?this.value.carForm.authType:0,
      submitLoading: false,
      state: 2,
      msg: ''
    }
  },
  methods: {

    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },

    msgChange(){
      this.carForm.remark = this.msg;
    },

    //提交
    submit() {
      if(this.state == 3 && !this.carForm.remark){
        this.$message({
          showClose: true,
          duration: 1500,
          message: '不通过原因不能为空',
          type: 'warning'
        })
        return;
      }
      this.$confirm(this.state == 2?'确定要给予【'+this.carForm.nickName+'】通过吗？':this.state == 3?'确定要给予【'+this.carForm.nickName+'】不通过吗？':'').then(() => {
        this.submitLoading = true;
        let _this = this;
        let param = {};
        param['id'] = this.carForm.id;
        param['userId'] = this.carForm.userId;
        param['schoolName'] = this.carForm.schoolName;
        param['state'] = this.state;
        param['authType'] = this.authType;
        param['remark'] = this.state == 3?this.carForm.remark:'';
        postFormData(updateAuthCar,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
            _this.$emit('close');
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.submitLoading = false;
        })
            .catch(function(response){
              _this.submitLoading = false;
            })
      })
          .catch(() => {})
    }
  },
  watch: {

  },
  mounted() {

  },
  created() {
  }

}
</script>

<style>

</style>
